var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar-nav-icon',{on:{"click":function (){ return this$1.$router.back(); }}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v(_vm._s(_vm.mdiArrowLeft))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }